import * as React from 'react';
import { Avatar, Table } from 'antd';
import { Reward } from 'src/store';
import { Subscription, Observable } from 'rxjs';
import { QuerySnapshot, Query } from '@firebase/firestore-types';
import * as firebase from 'firebase/app';
import { ColumnProps } from 'antd/lib/table';

interface Props {
    merchantId?: string | null;
}

interface S {
    data: Reward[];
    loading?: boolean;
    currentPage: number;
}

class RewardList extends React.Component<Props, S> {
    subscription: Subscription;
    columns: ColumnProps<Reward>[];
    queryRef: Query;
    pageSize: number;
    constructor(props: Props) {
        super(props);

        this.subscription = new Subscription();
        const { merchantId } = this.props;
        this.pageSize = 10;
        this.state = { data: [], loading: false, currentPage: 1 };
        this.queryRef = firebase.firestore().doc(`merchants/${merchantId}`)
            .collection('rewards')
            .orderBy('updatedAt', 'desc');
    }

    componentDidMount() {
        this.handlePageChange(1);
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    handlePageChange = (page: number) => {
        const paginatedRef = this.queryRef;
        this.setState({ loading: true });
        // if (page > 1) {
        //     paginatedRef = this.queryRef.endAt(page);
        // }

        const members$ = new Observable<QuerySnapshot>(observer => {
            return paginatedRef.onSnapshot(sn => observer.next(sn));
        });

        this.subscription = members$.subscribe(sn => {
            if (!sn.empty) {
                const data = sn.docs.map(d => ({ ...d.data(), id: d.id } as Reward));
                this.setState({ data, loading: false, currentPage: page });
            } else {
                this.setState({ data: [], loading: false, currentPage: page });
            }
        });
    }

    getDataSource = () => {
        const { data, loading, currentPage } = this.state;
        const page = loading ? 1 : currentPage;
        const ds = !loading ?
            data.map((obj, i) => ({
                no: ((page - 1) * this.pageSize) + (i + 1),
                key: obj.id,
                ...obj,
            })) : [];

        return {
            ds,
            page,
        };
    }
    render() {
        const { page, ds } = this.getDataSource();
        const { loading } = this.state;
        this.columns = [{
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            width: "5%",
            render: (text: string, record: Reward, index: number) => {
                return <span>{record.no}</span>;
            }
        },
        {
            title: 'Image',
            dataIndex: 'imageName',
            key: 'imageName',
            width: "10%",
            // tslint:disable-next-line:no-any
            render: (text: string, record: Reward) => (
                <span>
                    <Avatar
                        src={record.photo}
                        className="img-circle"
                    />
                </span>
            )
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '20%',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: '20%',
        },
            // {
            //     title: 'Phone',
            //     dataIndex: 'phoneNumber',
            //     key: 'phoneNumber',
            //     width: '15%',
            // },
            // {
            //     title: 'Created',
            //     dataIndex: 'creat',
            //     width: '15%',
            //     // tslint:disable-next-line:no-any
            //     render: (text: string, record: any) => {
            //         return <DisplayDate dateTime={record.metadata.creationTime} />
            //     }
            // },
            // {
            //     title: 'Signed In',
            //     dataIndex: 'creat',
            //     key: 'loginUserName',
            //     width: '15%',
            //     // tslint:disable-next-line:no-any
            //     render: (text: string, record: any) => {
            //         return <DisplayDate dateTime={record.metadata.lastSignInTime} />
            //     }
            // }
        ];
        return (
            <Table
                loading={loading}
                columns={this.columns}
                dataSource={ds}
                // onRow={this.handleOnRow}
                pagination={{
                    current: page || 0,
                    pageSize: this.pageSize,
                    total: ds.length || 0,
                    onChange: this.handlePageChange,
                    showTotal: (total) => <span className="total-count">Total Count: {total}</span>
                }}
                size="middle"
                bordered={true}
            />
        );
    }
}

export default RewardList;



// WEBPACK FOOTER //
// ./src/merchants/forms/RewardList.tsx